// File extension constants
export const IMAGE_EXTENSIONS = ['png', 'jpg', 'jpeg', 'gif', 'webp', 'heic', 'heif', 'bmp', 'svg']
export const VIDEO_EXTENSIONS = ['mp4', 'mov', 'avi', 'mkv', 'webm', 'flv', 'wmv', 'm4v', '3gp', 'hevc']
export const PREVIEWABLE_DOC_EXTENSIONS = ['pdf', 'docx']
export const NON_PREVIEWABLE_EXTENSIONS = ['doc', 'xls', 'xlsx', 'ppt', 'pptx', 'msword']

// File type for preview modal (more granular)
export type PreviewFileType = 'image' | 'video' | 'pdf' | 'docx' | 'document'

// File type for preview item (simpler)
export type ItemFileType = 'image' | 'video' | 'document'

/**
 * Get detailed file type for preview modal
 */
export const getPreviewFileType = (filenameOrMimeType: string): PreviewFileType => {
  const value = filenameOrMimeType.toLowerCase()
  
  if (value.startsWith('image/')) return 'image'
  if (value.startsWith('video/')) return 'video'
  if (value === 'application/pdf') return 'pdf'
  if (value.includes('wordprocessingml.document')) return 'docx'
  if (value.includes('msword') || value.includes('officedocument')) return 'document'
  
  const extension = value.split('.').pop() || ''
  if (IMAGE_EXTENSIONS.includes(extension)) return 'image'
  if (VIDEO_EXTENSIONS.includes(extension)) return 'video'
  if (extension === 'pdf') return 'pdf'
  if (extension === 'docx') return 'docx'
  if (NON_PREVIEWABLE_EXTENSIONS.includes(extension)) return 'document'
  
  return 'document'
}

/**
 * Get simple file type for preview item thumbnail
 */
export const getItemFileType = (filenameOrMimeType: string): ItemFileType => {
  const value = filenameOrMimeType.toLowerCase()
  
  if (value.startsWith('image/')) return 'image'
  if (value.startsWith('video/')) return 'video'
  
  const extension = value.split('.').pop() || ''
  if (IMAGE_EXTENSIONS.includes(extension)) return 'image'
  if (VIDEO_EXTENSIONS.includes(extension)) return 'video'
  
  return 'document'
}

/**
 * Check if file type can be previewed in modal
 */
export const isPreviewable = (filenameOrMimeType: string): boolean => {
  const value = filenameOrMimeType.toLowerCase()

  if (value === 'application/msword') return false // .doc
  if (value.includes('spreadsheetml') || value === 'application/vnd.ms-excel') return false // .xlsx, .xls
  if (value.includes('presentationml') || value === 'application/vnd.ms-powerpoint') return false // .pptx, .ppt
  if (value.startsWith('image/') || value.startsWith('video/')) return true
  if (value === 'application/pdf') return true
  if (value.includes('wordprocessingml.document')) return true
  
  const extension = value.split('.').pop() || ''
  if (IMAGE_EXTENSIONS.includes(extension)) return true
  if (VIDEO_EXTENSIONS.includes(extension)) return true
  if (PREVIEWABLE_DOC_EXTENSIONS.includes(extension)) return true
  if (NON_PREVIEWABLE_EXTENSIONS.includes(extension)) return false
  
  return false
}
